import { Ntext } from "components";
import React from "react";
import moment from "moment";
import { Link } from "gatsby";

const BlogPostCard = ({ colums = 2, article }) => {
  return (
    <Link
      to={`/blog/${article?.slug}`}
      className={`${colums === 2 ? "col-span-2" : "col-span-3"}`}
    >
      <div
        className={`h-[240px] p-4 rounded-3xl mb-4 `}
        style={{
          background: `url('https://strapi.nomba.com${article?.cover?.url}')`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="px-4 py-1.5 border-2 rounded-full w-fit border-[#666666] bg-[#80808029]">
          <Ntext
            variant="p"
            className="!text-[14px] !leading-[20px] !text-white !font-semibold"
          >
            {article?.category?.name}
          </Ntext>
        </div>
      </div>
      <div className="flex items-center gap-3 mb-3">
        <Ntext
          variant="p"
          className="!text-[#808080] !text-[16px] !leading-[24px] !font-medium"
        >
          {moment(article?.publishedAt).format("DD MMM. YYYY")}
        </Ntext>
        <div className="w-1 h-1 rounded-full bg-[#999999]" />
        <Ntext
          variant="p"
          className="!text-[#808080] !text-[16px] !leading-[24px] !font-medium"
        >
          {article?.duration} min{article?.duration > 1 ? "s" : ""} read
        </Ntext>
      </div>
      <Ntext
        className=" !text-[24px] !leading-[32px] !tracking-[-0.8px] font-bold mb-2"
        variant="p"
      >
        {article?.title}
      </Ntext>
      <Ntext
        variant="p"
        className="!text-[14px] !leading-[20px] !text-[#808080] w-full h-[40px] overflow-hidden text-ellipsis whitespace-normal line-clamp-2 mb-3"
      >
        {article?.description}
      </Ntext>
      <div className="flex items-center gap-2">
        <img
          src={`https://strapi.nomba.com${article?.author?.avatar?.url}`}
          alt="author's image"
          className="border-[1.6px] border-[#E6E6E6] w-6 h-6 rounded-full"
        />
        <Ntext
          variant="p"
          className=" !text-[16px] !leading-[24px] !font-semibold"
        >
          {article?.author?.name}
        </Ntext>
      </div>
    </Link>
  );
};

export { BlogPostCard };
